export const MIN_INTERVAL_SECOND = 5*60;
export const MIN_INTERVAL = 5;
export const NBD_GA_NOTIFICATION_SET = 'ga.action.notifications.before_due_date_set';
export const NBD_GA_NOTIFICATION_CHANGED = 'ga.action.notifications.before_due_date_changed';
export const NBD_GA_NOTIFICATION_CATEGORY = 'ga.category.notifications';
